export const ordiniConsipTableInitialState = {
    data: [],
    loading: false,
}

export const ordiniConsipDetailsInitialState = {
    data: [],
    loading: false,
}

export const simDaAttivareInitialState = {
    data: [],
    count: 0,
}

export const ordiniConsipDetailsOfferta = {
    data: {
        pianiVoceDatiList: [],
        pianiDataList: [],
        pachettiVoceSmsMms: [],
        pachettiDati: [],
        pachettiRoamingNonRegolamentato: []
    },
    loading: false
}

export const offertaRowDetails = {
    data: [],
    loading: false,
}

export const consipPlansInitialState = {
    data: [],
    loading: false,
}

export const simPrimariaInitialState = {
    data: {
        data: [],
        count: 0
    },
    loading: false,
}

export const simSecondariaSummaryInitialState = {
    data: {
        utenzaPrioritaria: "",
        tipologia: "",
        attivareRicaricaAutomatica: "",
        tipologiaDiAsseno: "",
        attivareAutomaticafast: "",
        comportamentoServizioDati: "",
        attivazionePacchettoRoamingExtraEuropa: "",
        apn: "",
        classeAbilitazioneDati: "",
        indirizzoEmailRefferente: ""
    },
    loading: false,
}

export const attivaSimSecondariaResponse = {
    data: [],
    loading: false
}